
import {initWebComponent} from "@/helpers/web-component-helper";
import {LayerInfoFilterSettingsComponent} from "@/components/layer/info/filter/layer-info-filter-settings-component";
import {LayerInfoFilterResultComponent} from "@/components/layer/info/filter/layer-info-filter-result-component";
import {LayerInfoFilterResultButtonComponent} from "@/components/layer/info/filter/buttons/layer-info-filter-result-button-component";
import {
    LayerInfoFilterSettingsButtonComponent
} from "@/components/layer/info/filter/buttons/layer-info-filter-settings-button-component";
import {LayerInfoFilterSwitcherComponent} from "@/components/layer/info/filter/layer-info-filter-switcher-component";
import {
    LayerInfoFilterResultChartButtonComponent
} from "@/components/layer/info/filter/buttons/layer-info-filter-result-chart-button-component";

export class LayerInfoFilterComponent extends HTMLElement {

    constructor() {
        super();

        let showClass = ''
        if(window.settings.ShowAllFilters === 2) {
            showClass = 'd-none'
        }

        const template = document.createElement('template');
        template.innerHTML = `
        <div class="card m-3 bg-lighter" data-test="layer_info_filter_card" style="border-radius: 10px;min-height: 335px;">
             <div class="card-header info-menu-info-draggable p-2">
                  <h2><span class="fa fa-filter title-icon"></span> Filter
                  <button class="btn icon-btn btn-sm btn-outline-secondary float-right btnCloseInfoMenu" data-parent-element="layer-info-filter">
                    <span class="fa fa-times"></span>
                 </button>
                  <button class="btn icon-btn btn-sm btn-outline-secondary float-right btnHideInfoMenu d-none">
                    <span class="fa fa-minus"></span>
                 </button>
                 </h2>
             </div>
            <div class="card-body pl-2 divFilterHelpText ${showClass}" style="margin-top:20px">
                <p>
                    Klik op <i class="fa fa-filter"></i> bij de catalogus om te filteren
                </p>
            </div>
             <layer-info-filter-switcher></layer-info-filter-switcher>
             <div id="divLayerErrorMessage"></div>
             <div id="divLayerInfoFilterSettings"></div>
             <div id="divLayerInfoFilterResult"></div>
        </div>
        `;

        initWebComponent(this, template)
    }
}

window.customElements.define("layer-info-filter-settings", LayerInfoFilterSettingsComponent);
window.customElements.define("layer-info-filter-result", LayerInfoFilterResultComponent);
window.customElements.define("layer-info-filter-result-chart-button", LayerInfoFilterResultChartButtonComponent);
window.customElements.define("layer-info-filter-result-button", LayerInfoFilterResultButtonComponent);
window.customElements.define("layer-info-filter-settings-button", LayerInfoFilterSettingsButtonComponent);
window.customElements.define("layer-info-filter-switcher", LayerInfoFilterSwitcherComponent);
